module.exports = "/assets/data/5e4008ae484f8a499726c9ad5636027e-FK8.data.json";